(function (upp) {
    'use strict';

    upp.controller('upp.plugins.login.ChangePasswordCtrl', ['$rootScope', '$routeParams', 'location', '$timeout',
        function ($rootScope, $routeParams, location, $timeout) {
            var token = $routeParams.token;

            if (token) {
                $timeout(function () {
                    $rootScope.$broadcast('changePasswordModal:open', {token: atob(token)});
                },1000);
            }

            location.path('/');
        }]);

}(upp));


// WEBPACK FOOTER //
// ./src/app/plugins/login/controllers/change-password-controller.js